// removed by extract-text-webpack-plugin
module.exports = {"table":"PowerSemiLossSummary__table","totalRow":"PowerSemiLossSummary__totalRow","maxRow":"PowerSemiLossSummary__maxRow","emptyRow":"PowerSemiLossSummary__emptyRow","lightBlue":"PowerSemiLossSummary__lightBlue","lightBlueHeader":"PowerSemiLossSummary__lightBlueHeader","blueHeader":"PowerSemiLossSummary__blueHeader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TableGroup/PowerSemiLossSummary.scss
// module id = ./src/components/TableGroup/PowerSemiLossSummary.scss
// module chunks = 2